(function($) {
    $(".career-role__title").on("click", function() {
        $(this).parent().toggleClass('active');
    }) 
})(jQuery);